import { html, LitElement } from 'lit-element';
import { DockPanel, Widget } from '@lumino/widgets';
import { customElement } from 'lit/decorators.js';


import { css, unsafeCSS } from 'lit';
import styles_widget from  '@lumino/widgets/style/widget.css';
import styles_accordionpanel from  '@lumino/widgets/style/accordionpanel.css';
import styles_commandpalette from  '@lumino/widgets/style/commandpalette.css';
import styles_dockpanel from  '@lumino/widgets/style/dockpanel.css';
import styles_menu from  '@lumino/widgets/style/menu.css';
import styles_menubar from  '@lumino/widgets/style/menubar.css';
import styles_scrollbar from  '@lumino/widgets/style/scrollbar.css';
import styles_splitpanel from  '@lumino/widgets/style/splitpanel.css';
import styles_tabbar from  '@lumino/widgets/style/tabbar.css';
import styles_tabpanel from '@lumino/widgets/style/tabpanel.css';



@customElement('pdq-ui-dock')
export class PdqUiDock extends LitElement {

  // static styles = [
  //   styles_widget,
  //   styles_accordionpanel,
  //   styles_commandpalette,
  //   styles_dockpanel,
  //   styles_menu,
  //   styles_menubar,
  //   styles_scrollbar,
  //   styles_splitpanel,
  //   styles_tabbar,
  //   styles_tabpanel,
  //   css`
  //     :host {
  //       display: block;
  //       width: 100%;
  //       height: 100%;
  //       overflow: hidden;
  //       background: #f0f0f0;
  //     }
  //
  //   `
  // ].map(unsafeCSS);

  private dock: DockPanel;



  createWidget(title: string, content: string) {
    let widget = new Widget();
    widget.node.classList.add('dock-widget');

    // Create a title element
    let header = document.createElement('h3');
    header.textContent = title;

    // Create content
    let contentDiv = document.createElement('div');
    contentDiv.innerHTML = content;

    // Append elements
    widget.node.appendChild(header);
    widget.node.appendChild(contentDiv);

    return widget;
  }

  connectedCallback() {
    super.connectedCallback();

    this.dock = new DockPanel()

    this.dock.addWidget(this.createWidget('Panel 1', '<p>This is the first panel.</p>'));
    this.dock.addWidget(this.createWidget('Panel 2', '<p>This is the 2nd panel.</p>'), { mode: 'split-right' });
    this.dock.addWidget(this.createWidget('Panel 3', '<input type="text" placeholder="Type here...">'), { mode: 'split-bottom' });



    this.shadowRoot?.appendChild(this.dock.node);

    const style = document.createElement('style');
    style.innerHTML =  [
      styles_widget,
      styles_accordionpanel,
      styles_commandpalette,
      styles_dockpanel,
      styles_menu,
      styles_menubar,
      styles_scrollbar,
      styles_splitpanel,
      styles_tabbar,
      styles_tabpanel
    ].join('\n');
    this.shadowRoot?.appendChild(style)

    this.dock.update();

    setTimeout(() => {
      this.dock.update();
    }, 1000);
  }
}